import { AccountProfileLinkType } from '@models/accounts';
import { getSocialPlatformIcon } from '@shared/socialPlatforms';
import classNames from 'classnames';

export default function SocialLinkWithIcon({
  url = '',
  type,
  color = '#fff'
}: {
  url?: string;
  type: AccountProfileLinkType;
  color?: string;
}) {
  return (
    <a href={url} target='_blank' rel='noreferrer'>
      <div className={classNames('flex flex-row justify-between')}>
        <div
          className={classNames(
            'w-huge h-huge',
            'hover:scale-105 transition-all hover:opacity-80',
            'flex items-center justify-center'
          )}
          style={{ color: color }}
        >
          {getSocialPlatformIcon(type, 32)}
        </div>
      </div>
    </a>
  );
}
